const Commitments = {
  index: { as: '/commitments', href: '/commitments' },
  tracker: { as: '/commitments/track', href: '/commitments/track' },
};
export default Commitments;
